// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__jA3BP","visible":"tooltip_visible__3OjBO"};